import React from 'react'
import styled from 'styled-components'
import { colors } from '../../styles/colors';

const Container = styled.section`
    width: 200px;
    height: 60px;

    padding: 1.5rem 2rem;

    background: ${ props => props.disabled ? 'grey' : props.lighten ? colors.white : colors.dark_blue};
    color: ${  props => props.lighten ? colors.dark_blue : colors.white};

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 10px;
    cursor: ${props => props.disabled ? 'auto' : 'pointer'};
    ${props => props.disabled ? 'pointer-events: none;' : null }

    transition: all .25s;

    .consultation-button_text {
        font-family: 'SF UI Text Light', sans-serif;
        font-size: 1.75rem;
        line-height: 2rem;
        letter-spacing: .25rem;
        white-space: normal;
    }

    :hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    ${  props => props.lighten ? 'svg path { fill: ' + colors.dark_blue + ' }' : null }
`;

export const ConsultationButton = ({ disabled, onclick, lighten }) => {

    return (
        <Container className='consultation-button' disabled={disabled} lighten={lighten} onClick={ onclick ? onclick : null} >
            <span className="consultation-button_text">Получить консультацию</span>
            <div className="consultation-button_ico">
                <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.7676 20C13.7676 20 9.4027 10.5397 1.76404 2.10209C-5.87462 -6.33549 13.7676 13.3522 13.7676 13.3522C13.7676 13.3522 33.021 0.312304 29.5906 2.61346C26.1601 4.91462 13.7676 20 13.7676 20Z" fill="white" />
                </svg>
            </div>
        </Container>
    )
}
